import { makeStyles } from "@material-ui/core/styles";

// D8.10.1 — Estilos de UpdateVersionModal (extraídos del god file).
export const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: Root dinámico según tema
  root: {
    "& .MuiDialog-paper": {
      minWidth: 500,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    },
  },
  // ✅ CORREGIDO: Content dinámico según tema
  content: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: ProgressContainer dinámico según tema
  progressContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: StatusText dinámico según tema
  statusText: {
    marginTop: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.primary,
  },
  alert: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  errorAlert: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
  },
  infoAlert: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText,
  },
  successAlert: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.contrastText,
  },
  updateButton: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  progressBar: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  stepsList: {
    marginTop: theme.spacing(2),
  },
  stepItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  stepIcon: {
    marginRight: theme.spacing(1),
  },
}));
